export { default } from "./tabs-items";
